import * as fetch from 'isomorphic-fetch';
import { BffSource } from 'bernie-core';
export class LoyaltySource extends BffSource {
    constructor(logger) {
        super('', logger, {}, {});
    }
    fetch(options) {
        const { site: { id }, locale } = options.context;
        const tuid = options.tuid;
        const url = `${this.host}/gc/memberDetails/${id}/${tuid}/${locale}`;
        return fetch(url, { method: 'GET' }).then(res => res.json().then(response => ({ loyalty: response })));
    }
}
//# sourceMappingURL=loyalty-source.js.map